import React from 'react';
import { Icon } from '../Icon';
import * as S from './styles';

var Badge = function Badge(_ref) {
  var children = _ref.children,
      _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? 'grey' : _ref$colorScheme,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'md' : _ref$variant,
      _ref$border = _ref.border,
      border = _ref$border === void 0 ? false : _ref$border,
      _ref$rounded = _ref.rounded,
      rounded = _ref$rounded === void 0 ? false : _ref$rounded,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? '' : _ref$icon,
      _ref$onClickIcon = _ref.onClickIcon,
      onClickIcon = _ref$onClickIcon === void 0 ? function () {
    return null;
  } : _ref$onClickIcon;
  return React.createElement(S.BadgeWrapper, {
    variant: variant,
    colorScheme: colorScheme,
    border: border,
    rounded: rounded,
    icon: icon
  }, children, icon && React.createElement(S.IconContainer, null, React.createElement(Icon, {
    name: icon,
    variant: 'regular',
    fill: '#fff',
    height: 20,
    onClick: onClickIcon
  })));
};

export { Badge };